// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2KLbf","requiredAsterisk":"Info_requiredAsterisk__qKmKA"};